!function ($) {
    "use strict";

}(window.jQuery),
function ($) {
    'use strict';

    var NotificationApp = function () {
    };

    NotificationApp.prototype.send = function (heading, body, position, loaderBgColor, icon, hideAfter, stack, showHideTransition) {
        // default
        if (!hideAfter)
            hideAfter = 3000;
        if (!stack)
            stack = 1;

        var options = {
            heading: heading,
            text: body,
            position: position,
            loaderBg: loaderBgColor,
            icon: icon,
            hideAfter: hideAfter,
            stack: stack
        };

        if (showHideTransition)
            options.showHideTransition = showHideTransition;
        else
            options.showHideTransition = 'fade';

        $.toast().reset('all');
        $.toast(options);
    },

        $.NotificationApp = new NotificationApp, $.NotificationApp.Constructor = NotificationApp

}(window.jQuery),

function ($) {
    'use strict';

    var AdvanceFormApp = function () {
        this.$body = $('body'),
        this.$window = $(window)
    };

    /**
     * Initlizes the select2
     */
    AdvanceFormApp.prototype.initSelect2 = function () {
        // Select2
        $('[data-toggle="select2"]').select2();
    },

    /**
     * Initilize
     */
    AdvanceFormApp.prototype.init = function () {
        this.initSelect2();
    },

    $.AdvanceFormApp = new AdvanceFormApp, $.AdvanceFormApp.Constructor = AdvanceFormApp


}(window.jQuery),

function ($) {
    'use strict';

    var App = function () {
        this.$body = $('body'),
            this.$window = $(window)
    };

    /**
     * initilizing
     */
    App.prototype.init = function () {

        $.AdvanceFormApp.init();

    },

    $.App = new App, $.App.Constructor = App
}(window.jQuery);

document.addEventListener("turbolinks:before-cache", function() {
    $('[data-toggle="select2"]').select2('destroy');
});

document.addEventListener("turbolinks:load", function (e) {
    $.App.init();
});